<template>
  <div class="flex flex-col grow bg-gray-50">
    <div class="container flex flex-col gap-1 grow py-7 md:py-14">
      <slot />
    </div>
  </div>
</template>
